<template>
  <div>
    <div :class="auto_changes === false ? 'p-4' : ''">
      <!--        <ads-selector></ads-selector>-->
      <div
        :class="auto_changes === false ? 'p-0 mt-5 pt-5' : 'px-4 py-0 my-0'"
        style="border: none !important"
      >
        <v-col class="py-0 my-0">
          <categoryselector
            v-if="adv === false"
            ref="category"
            :multiAdsCat="false"
            @category-current="getCurrent"
          ></categoryselector>
        </v-col>
        <v-col class="col-md-8 mx-auto py-0 my-0">
          <city-selector
            ref="city"
            :MultiCity="auto_changes === true || adv === true ? false : true"
            :auto_change="auto_changes"
            :force="true"
            :smart="adv"
            class="py-0"
          ></city-selector>
        </v-col>
        <div v-if="estate" class="col-md-8 mx-auto py-0 my-0">
          <get-panels-number panel-type="divar_real_estate"></get-panels-number>
        </div>
        <div
          v-for="(item, index) in properties"
          class="col-md-8 mx-auto my-0 py-0"
        >
          <component
            :is="item.has_fields ? 'InDialogRangeField' : item.component"
            :key="item.name"
            :fields="item.has_fields"
            :items="item.items"
            :label="item.label"
            :max="item.counter"
            :maxLength="item.max"
            :min="item.min"
            :multiple="item.multi"
            :name="item.name"
            :placeholder="item.placeholder"
            :type="item.type"
            :value="item.value"
            chips
            clear-icon="mdi-close-circle-outline"
            clearable
            deletable-chips
            dense
            item-text="lable"
            item-value="key"
            oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max; else if(Number(this.value) < Number(this.min) && this.type === 'number') this.value = this.min;"
            outlined
            prepend-inner-icon="fa fa-pencil-alt"
            small-chips
            @change="getBooleanValue($event, item.name, item.Fielad_type)"
            @input="getValues($event, item.name, item.Fielad_type, item)"
          >
          </component>
        </div>
        <div class="col-md-8 mx-auto my-0 py-0">
          <v-text-field
            v-model="schemas.key_word"
            :rules="[rules.maxTwoWord]"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hint="دقت کنید : این کلمه در جستجوی دسته ی منتخب فیلتر خواهد شد."
            label="کلمه کلیدی"
            name="keyword"
            outlined
            prepend-inner-icon="fa fa-pencil-alt"
          ></v-text-field>
        </div>
        <div class="col-md-8 mx-auto">
          <v-btn
            v-if="schemas.category !== ''"
            class="text-dark"
            color="warning"
            @click="schemaset"
            :disabled="!canCheck"
          >
            <!--            <span class="material-icons">verified_user</span>-->
            اعتبارسنجی
          </v-btn>
          <p v-if="searchResults.length <= 0" class="text-center text-danger">
            برای مشاهده آگهی های مشابه موردنظر باید روی دکمه اعتبار سنجی کلیک
            کنید
          </p>
        </div>
        <v-row class="mx-auto px-5">
          <v-col
            v-for="(item, index) in computeResult"
            v-if="searchResults.length > 0"
            class="col-md-4"
          >
            <v-card
              :key="item.token"
              :color="tokens.indexOf(item.token) > -1 ? 'red' : '#191179'"
              class="text-white"
              dark
              elevation="4"
              max-height="400"
              searchResults
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title
                    style="font-size: 9pt; font-weight: bold"
                    v-text="item.place"
                  ></v-card-title>
                  <v-card-subtitle v-text="item.title"></v-card-subtitle>
                  <div class="row px-2">
                    <v-card-subtitle v-text="item.price"></v-card-subtitle>
                    <v-card-subtitle v-text="item.data"></v-card-subtitle>
                  </div>
                </div>
                <v-avatar class="ma-3" size="115">
                  <v-img
                    :src="
                      item.image
                        ? item.image
                        : require('@/assets/img/rblandNotext.webp')
                    "
                  ></v-img>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
          <v-col v-if="failedData === true">
            <v-img
              class="mx-auto"
              max-height="400"
              max-width="400"
              src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg"
            >
            </v-img>
            <p class="text-center">نتیجه ای وجود ندارد!</p>
          </v-col>
          <v-btn
            v-if="searchResults.length >= 3"
            class="mx-auto"
            outlined
            rounded
            @click="more = !more"
          >
            <v-icon class="ml-2">mdi-eye</v-icon>
            {{ more ? "مشاهده نتایج کمتر" : "مشاهده نتایج بیشتر" }}
          </v-btn>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import { Bus } from "@/main";
import Categoryselector from "@/view/pages/ads/categorySelector";
import CitySelector from "@/view/pages/ads/citySelector";
import InDialogRangeField from "@/view/pages/ads/similarAds/InDialogRangeField";
import Swal from "sweetalert2";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import {
  VAutocomplete,
  VSelect,
  VSwitch,
  VTextarea,
  VTextField,
} from "vuetify/lib";
import GetPanelsNumber from "@/view/pages/ads/singleAds/agency/getPanelsNumber";

export default {
  name: "similarAds",
  components: {
    GetPanelsNumber,
    ButtonTempl,
    CitySelector,
    Categoryselector,
    TitleRibbon,
    InDialogRangeField,
    VAutocomplete,
  },
  props: {
    auto_changes: {
      default: false,
      require: true,
    },
    cats: {
      default: "",
    },
    adv: {
      default: false,
    },
    estate: {
      default: false,
    },
    taze: {
      default: false,
    },
    correctAuth: {
      default: false,
    },
  },
  data() {
    return {
      result: [],
      tokens: [],
      searchResults: [],
      current: "",
      minPrice: "",
      schemas: {
        key_word: "",
        last_post: 0,
        other_filters: {
          districts: {
            repeated_string: {
              value: [],
            },
          },
        },
      },

      maxPrice: "",
      translates: [],
      failedData: false,
      more: false,
      properties: [],
      searchFields: [],
      city: "",
      neighborhood: "",
      inputs: {
        radio: VSelect,
        string: VTextField,
        number: VTextField,
        hierarchy_widget: VSelect,
        SingleSelectHierarchyWidget: VSelect,
        select: VAutocomplete,
        textarea: VTextarea,
        boolean: VSwitch,
        // "hidden": VHidden,
        array: VAutocomplete,
        object: VAutocomplete,
      },
      rules: {
        maxTwoWord: (n) =>
          !n?.length ||
          n.split(" ").filter((x) => x).length <= 2 ||
          "حداکثر دو کلمه باید وارد شود.",
      },
    };
  },
  methods: {
    translator(name) {
      return this.translates[name];
    },
    getAds() {
      const category = this.cats !== "" ? this.cats : this.current;

      $.ajax({
        url: `${url}/divar/categories/${category}/search/fields`,
        method: "POST",
        fn: this.getAds,
        headers: {
          Authorization: Token,
          ACCEPT: "application/json",
        },
        success: (res) => {
          this.searchFields = res.data;
        },
      });
    },
    getNewCategories() {
      if (localStorage.getItem("searchCategory")) {
        this.translates = JSON.parse(localStorage.getItem("searchCategory"));
        return;
      }
      $.ajax({
        url: `${url}/setting/search/category`,
        type: "GET",
        fn: this.getNewCategories,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.translates = data.data;
          localStorage.setItem("searchCategory", JSON.stringify(data.data));
        },
      });
    },
    getTokens() {
      $.ajax({
        url: `${url}/advertise/tokens`,
        type: "GET",
        fn: this.getNewCategories,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.tokens = data.data;
        },
      });
    },
    getCurrent: function (value) {
      this.current = value;
    },
    getProperty(key) {
      const name = key.name;
      const min = key.min;
      const max = key.max;
      const help = key.placeholder;
      const requireField = key.required;
      const placeholder = "جستجوی " + key.label + " " + "موردنظر";
      const autoReload = key.auto_refresh;
      const has_field = key.fields;
      let items = [];
      let type =
        key.field_type !== null
          ? key.field_type
          : key.field_type !== "integer"
          ? key.field_type
          : "number";
      let title = key.label;
      let itemValue = key.enum ?? [];
      let itemText = key.enumNames ?? itemValue;

      if (itemValue.length)
        itemValue.forEach((item, index) => {
          items.push({
            lable: item,
            key: itemText[index],
          });
        });

      const multi = type !== "str";

      return {
        component: "VAutocomplete",
        label: title,
        counter: max ? max : null,
        hint: help ? help : null,
        value: "",
        required: requireField,
        errorMessage: "",
        autoReload: autoReload,
        has_fields: has_field,
        type,
        multi,
        placeholder,
        items,
        name,
        min,
      };
    },
    getValues(esm, name, field, item) {
      this.searchResults = [];

      this.schemas.other_filters[name] =
        esm !== null
          ? {
              [item["type"]]: { value: esm },
            }
          : [];
    },
    getBooleanValue(val, name, field) {
      this.searchResults = [];
      if (field === "boolean") {
        this.schemas.other_filters[name] = val;
      } else return;
    },
    schemaset() {
      const data = this.schemas;

      if (this.city === "") {
        this.$nextTick(function () {
          this.$modal.error(
            "خطا!",
            "شما برای اعتبار سنجی نیاز به انتخاب شهر دارید."
          );
        });
        return;
      }
      const category = this.cats !== "" ? this.cats : this.current;
      this.schemaset["category"] = category;
      $.ajax({
        url: `${url}/divar/search/category`,
        method: "POST",
        fn: this.schemaset,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
        success: (res) => {
          if (res.data.length === 0) {
            this.searchResults = [];
            this.failedData = true;
            this.correctAuth = false;
            Swal.fire({
              title:
                "اعتبار سنجی با شکست مواجه شد! لطفا فیلدهای ورودی را چک کنید.",
              icon: "error",
            });
          } else {
            this.searchResults = [];
            this.correctAuth = true;
            this.searchResults = res.data;
            this.failedData = false;
          }
        },
      });
    },
  },
  computed: {
    computeResult() {
      if (!this.more) {
        return this.searchResults.slice(0, 3);
      } else {
        return this.searchResults;
      }
    },
    canCheck() {
      return typeof this.rules.maxTwoWord(this.schemas.key_word) === "boolean";
    },
  },
  watch: {
    searchFields() {
      this.properties = [];

      const filtered = this.searchFields.filter(
        (x) =>
          x.type !== "hidden" &&
          x.name !== "category" &&
          x.name !== "districts" &&
          x.name !== "divider"
      );

      filtered.forEach((item) => {
        this.properties.push(this.getProperty(item));
      });
    },
    correctAuth: {
      handler: (value) => {
        Bus.$emit("correctAuth", value);
      },

      deep: true,
    },
    schemas: {
      deep: true,
      handler(val) {
        Bus.$emit("getSimilarData", val);
      },
    },
    city() {
      Bus.$emit("getSimilarData", this.schemas);
      this.searchResults = [];
    },
    searchResults() {
      Bus.$emit("Authenticate", this.searchResults);
    },
  },
  mounted() {
    this.getNewCategories();
    this.getTokens();
    Bus.$on("category-current", (current) => {
      this.current = current;
      this.schemas["category"] = Bus.getProp("category_current");
      this.getAds();
    });

    Bus.$on("dialogRange", (name, value = null) => {
      this.schemas.other_filters[name] = value;
      if (value != null) {
        this.searchResults = [];
      }
    });
    Bus.$on("cityInfo", (value) => {
      if (value.city !== undefined) {
        this.city = value.city;
        this.schemas["cities"] = value.city.map((item) =>
          typeof item === "number" && item !== null ? String(item) : item
        );
        // this.schemas["cities"] = Array.isArray(value.city)
        //   ? value.city.map((item) =>
        //       typeof item === "object" && item !== null
        //         ? String(item.id)
        //         : String(item)
        //     )
        //   : [
        //       typeof value.city === "object" && value.city !== null
        //         ? String(value.city.id)
        //         : String(value.city),
        //     ];
      }
      if (value.neighborhood !== undefined) {
        this.searchResults = [];
        this.neighborhood = String(value.neighborhood);
        this.schemas.other_filters["districts"] = {
          repeated_string: {
            value: String(value.neighborhood), //.split(',')
          },
        };
      }
      if (
        Array.isArray(
          this.schemas?.other_filters?.["districts"]?.["repeated_string"]?.value
        ) &&
        this.schemas.other_filters["districts"]?.["repeated_string"]?.value
          .length === 1
      ) {
        this.schemas.other_filters["districts"] = {
          repeated_string: { value: [] },
        };
      }
      if (value.neighborhood && value.neighborhood.length === 0) {
        delete this.schemas.other_filters["districts"];
      }
    });
  },
};
</script>

<style>
.fa-pencil-alt {
  font-size: 12.5pt !important;
}
</style>
